import { create } from "zustand";

const TOKEN_KEY = "rdp_token";
const USER_KEY  = "rdp_user";

interface AuthState {
  token: string | null;
  username: string | null;
  loading: boolean;
  error: string | null;
}

interface AuthActions {
  login(username: string, password: string): Promise<void>;
  logout(): void;
}

export const useAuthStore = create<AuthState & AuthActions>((set) => ({
  token:    localStorage.getItem(TOKEN_KEY),
  username: localStorage.getItem(USER_KEY),
  loading:  false,
  error:    null,

  async login(username, password) {
    set({ loading: true, error: null });
    try {
      const res = await fetch("/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.detail ?? "Login failed");
      }
      const data = await res.json();
      localStorage.setItem(TOKEN_KEY, data.access_token);
      localStorage.setItem(USER_KEY, data.username);
      set({ token: data.access_token, username: data.username, loading: false });
    } catch (e) {
      set({ loading: false, error: e instanceof Error ? e.message : "Login failed" });
    }
  },

  logout() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    set({ token: null, username: null });
  },
}));

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}
